export default __webpack_public_path__ + "static/media/error_pay.c8a516ec.svg";